<div
  class="procedure-content-list object-procedure-content-list-source"
  [ngClass]="{'smallScreen': smallScreen}"
>
 <div class="procedure-content-list__headline">
   @if (operationContainer.contentInfo.curListName !== 'spectrum_procedure_object') {
     <div class="procedure-content-list__title">
       @if (smallScreen) {
         <a
           (click)="onToggleMenu()"
           class="procedure-content-list__toggle-button"
         >
           <mat-icon>
             {{openMenu ? 'menu_open' : 'menu'}}
           </mat-icon>
         </a>
       }

       @if (operationContainer.contentInfo.selectedMainMenu) {
         <h3 class="bold">
           <span>
             {{operationContainer.contentInfo.curContentListSource?.array.length}} &nbsp;
           </span>

           <span>
             {{ operationContainer.contentInfo.curContentListSource?.caption | translate }}
           </span>
         </h3>
       }
     </div>

     <div>
       @if (!parentOperation?.sub_operations) {
         <ng-container>
           <button
             mat-flat-button
             type="button"
             class="add-button"
             color="primary"
             (click)="openModal()"
             [disabled]="isEditing || operationContainer.rootSectionsContainer.rootObject.read_only"
           >
             <mat-icon>
               add
             </mat-icon>

             <span class="bold uppercase">
               {{ 'TRANS__HEADER__OBJECT_MENU__ADD' | translate }}
             </span>
           </button>
         </ng-container>
       }
       @else {
         <ng-container>
           @if (parentOperation?.sub_operations?.length) {
             <app-operation-menus-two-levels
               class="procedure-content-list__operation-buttons"
               [operationContainer]="operationContainer"
               [parentOperation]="parentOperation"
             ></app-operation-menus-two-levels>
           }
         </ng-container>
       }

       @if (operationContainer.contentInfo.curListName === 'images' && !smallScreen) {
         <button
           mat-stroked-button
           color="primary"
           class="procedure-content-list__change-image-order-button"
           [disabled]="operationContainer.art?.$?.mediaTypes.length === 0"
           (click)="onToggleChangeImageOrder()"
         >
           <mat-icon>
             unfold_more
           </mat-icon>

           <span class="bold uppercase">
             {{ 'TRANS__THUMBNAIL_STACK__CHANGE_IMAGE_ORDER' | translate }}
           </span>
         </button>
       }
     </div>
   }
 </div>


  <div class="procedure-content-list__content-list">
    @if (operationContainer.contentInfo.curContentListSource) {
      <app-object-content-list-source-array
        [contentListSource]="operationContainer.contentInfo.curContentListSource"
        (objectRefresh)="loadProcedure()"
        (newObjectCreated)="onNewObjectCreated($event)"
      ></app-object-content-list-source-array>
    }
  </div>

  @if (!operationContainer.contentInfo.curListContainer && !operationContainer.contentInfo.curContentListSource) {
    <div>
      <span>
        {{ 'TRANS__CONTENT_LIST__NO_CONTENT' | translate }}
      </span>
    </div>
  }
</div>

